/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ProfitMarginCreateUpdateDTO interface.
 */
export function instanceOfProfitMarginCreateUpdateDTO(value) {
    return true;
}
export function ProfitMarginCreateUpdateDTOFromJSON(json) {
    return ProfitMarginCreateUpdateDTOFromJSONTyped(json, false);
}
export function ProfitMarginCreateUpdateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'minCost': json['minCost'] == null ? undefined : json['minCost'],
        'maxCost': json['maxCost'] == null ? undefined : json['maxCost'],
        'minProfit': json['minProfit'] == null ? undefined : json['minProfit'],
        'maxProfit': json['maxProfit'] == null ? undefined : json['maxProfit'],
    };
}
export function ProfitMarginCreateUpdateDTOToJSON(json) {
    return ProfitMarginCreateUpdateDTOToJSONTyped(json, false);
}
export function ProfitMarginCreateUpdateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'minCost': value['minCost'],
        'maxCost': value['maxCost'],
        'minProfit': value['minProfit'],
        'maxProfit': value['maxProfit'],
    };
}
